import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { ErrorBoundary } from '@/shared/components/common/ErrorBoundary';
import { ThemeProvider } from '@/app/providers/ThemeProvider';
import { AuthProvider } from '@/features/auth/context/AuthProvider';
import { AuthorizationProvider } from '@/features/auth/context/authorization';
import { Router } from '@/app/Router';
import { queryClient } from '@/shared/lib/queryClient';

export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider defaultTheme="system" storageKey="expense-mgmt-theme">
          <AuthProvider>
            <AuthorizationProvider>
              <Router />
              <Toaster
                position="bottom-right"
                toastOptions={{
                  duration: 5000,
                  style: {
                    borderRadius: '8px',
                    background: '#333',
                    color: '#fff',
                  },
                }}
              />
            </AuthorizationProvider>
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
